<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Add button -->
      <div  class="text-right">
        <router-link v-if="rol == 'admin'" :to="{ name: 'egreso-crear' }">
          <b-button variant="primary" class="btn-create-new">
            <i class="ni ni-fat-add"></i>  {{ $t('crear_egreso') }}
          </b-button>
        </router-link>
      </div>
    </base-header>
    
    <b-container fluid class="mt--7">
      <b-row>
         <b-col>
          <EgresoTable />
        </b-col> 
      </b-row>
      <!-- <div class="mt-5"></div>
      <dark-table></dark-table> -->
    </b-container>
  </div>
</template>
<script>
import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
import EgresoTable from "./EgresoTable.vue";
import utilsService from '@/api/utilsService';


export default {
  components: {
    EgresoTable,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    rol() {
      return utilsService.getRol();
    }
  },
  data(){
    return {
      grupoEstado: 0
    }
  },
  beforeMount(){    
    this.grupoEstado = this.$route.params.grupo;
  }
};
</script>
<style>
i.ni.ni-fat-add::before {
    vertical-align: middle;
}
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
